<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>資訊</f7-nav-title>
    </f7-navbar>

    悠遊餐飲國際有限公司<br>
    (02)2910-7978 羅先生<br>
    0931-192-298 羅先生<br>
    <a @click="openOfficialWebsite">官網: www.ezmeals.tw</a><br>
    建置版本: {{ version }}<br>
    <f7-button
      style="margin: 30px;"
      fill
      raised
      @click="clearCache">
      Clear Cache
    </f7-button>
  </f7-page>
</template>

<script>
import localforage from 'localforage'

export default {
  data () {
    return {
      version: process.env.VUE_APP_VERSION
    }
  },
  props: {
    storeIdPathParam: String
  },
  methods: {
    clearCache () {
      localforage.clear()
    },
    openOfficialWebsite () {
      window.open('http://www.ezmeals.tw', '_blank')
    }
  }
}
</script>
